<template>
  <div class="registration">
    <div class="title-section">
      <h1 class="page-title">{{$t('registration.emailVerification.title')}}</h1>
      <p class="description" v-if="phoneNumber && email" v-html="$t('registration.emailVerification.subtitleMobile', {email: email, phoneNumber: phoneNumber})"></p>
      <p class="description" v-else-if="!phoneNumber && email" v-html="$t('registration.emailVerification.subtitleFixed', {email: email})"></p>
    </div>
    <verification-email @data-fetched="getChildData"/>
  </div>
</template>

<script>
import VerificationEmail from '@/components/registration/verification-email'

export default {
  name: 'page-email-verification',
  components: { VerificationEmail },
  data () {
    return {
      phoneNumber: '',
      email: ''
    }
  },
  methods: {
    getChildData (data) {
      if (data.phoneNumber) this.phoneNumber = data.phoneNumber
      if (data.email) this.email = data.email
    }
  }
}
</script>

<style scoped lang="scss">
</style>
